module.exports = __webpack_public_path__ + "img/005b0c6662f6496da27681b55c4a1709.00b818c2.png";